import axios from "axios";
import { ACADEMY_BASE_URL, BASE_URL } from "App/constants";
import { getAcademyId } from "Utils/utils";

interface PlayerEngagementParams {
  academyId: number;
  playerId?: number;
  startDate: string;
  endDate: string;
}

export const fetchPlayerEngagementScore = async function (
  params: PlayerEngagementParams
) {
  const { academyId, playerId, ...queryParams } = params;

  const resolvedAcademyId = getAcademyId(academyId);
  const userAcademyId = getAcademyId();
  const url = userAcademyId
    ? `${ACADEMY_BASE_URL}${resolvedAcademyId}/players/${playerId}/app_engagement_score`
    : `${BASE_URL}players/${playerId}/app_engagement_score`;

  const { data } = await axios.get(url, {
    params: {
      start_date: queryParams.startDate,
      end_date: queryParams.endDate,
    },
  });

  return data;
};
